import React from "react";
import { useDispatch, useSelector } from "react-redux";

import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";

const MembershipTypeFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.numberOfActiveMembersBy.filters.membership_types);
  const selectedFilters = useSelector(
    (state) => state.numberOfActiveMembersBy.selectedFilters.membership_types
  );

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      placeholder="Not selected"
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      onSelectChange={(data) => dispatch(actionCreators.updateFilters({ membership_types: data }))}
    />
  );
};

export default MembershipTypeFilter;
